import React from "react";

import { Navigate } from "react-router";

import usePaths from "../common/hooks/usePaths";

const DashboardRedirectComponent = () => {
  const { getSpacesHome } = usePaths();
  const url = new URL(window.location.href);
  return <Navigate to={getSpacesHome() + url.search} />;
};

export default DashboardRedirectComponent;
